export const CALCULATOR = {
  eyebrow: "Pricing Calculator",
  title: "Υπολόγισε το κόστος της παραγγελίας σου",
  subtitle:
    "Διάλεξε μέγεθος οθόνης και ποσότητα για άμεση τιμή με εκπτώσεις όγκου και στείλε μας αίτημα παραγγελίας.",
  validityNote: "Οι τιμές ισχύουν για 14 ημέρες.",
  inclusiveNote:
    "Η τιμή είναι all-inclusive: παραγωγή, αποστολή, εισαγωγή & παράδοση εντός Ελλάδος. Χωρίς κρυφές χρεώσεις.",
  noPaymentNote: "Καμία πληρωμή τώρα. Επιβεβαιώνουμε την παραγγελία μέσω email πρώτα.",
};
